<template>
  <div v-if="navigation.visible" class="page-navigation" :class="{ 'page-navigation--complete': !navigation.pending }" role="status" aria-live="polite">
    <div class="page-navigation__track" aria-hidden="true"><span /></div>
    <span v-if="navigation.pending" class="page-navigation__label">Открываем страницу…</span>
    <span v-else class="page-navigation__sr">Страница открыта</span>
  </div>
  <div v-if="navigation.error" class="page-navigation__error" role="alert">
    <span>{{ navigation.error }}</span>
    <button type="button" aria-label="Закрыть сообщение" @click="navigation.error = ''">×</button>
  </div>
</template>

<script>
import { pageNavigation } from '@/services/page-navigation'
export default { setup: () => ({ navigation: pageNavigation }) }
</script>

<style scoped>
.page-navigation { position: fixed; inset: 0 0 auto; z-index: 10000; pointer-events: none; }
.page-navigation__track { height: 3px; background: #f6d8de; overflow: hidden; }
.page-navigation__track span { display: block; width: 40%; height: 100%; background: #db3454; animation: page-loading 1s ease-in-out infinite; }
.page-navigation--complete .page-navigation__track span { width: 100%; animation: none; }
.page-navigation__label { position: absolute; top: 12px; right: 16px; padding: 8px 12px; border-radius: 8px; background: #fff; color: #25282b; box-shadow: 0 2px 12px #0002; font-size: 14px; }
.page-navigation__sr { position: absolute; width: 1px; height: 1px; overflow: hidden; clip-path: inset(50%); }
.page-navigation__error { position: fixed; z-index: 10001; top: 12px; left: 50%; transform: translateX(-50%); width: min(520px, calc(100% - 24px)); display: flex; align-items: center; gap: 16px; padding: 16px; border-radius: 12px; background: #fff; box-shadow: 0 2px 16px #0003; color: #25282b; }
.page-navigation__error button { margin-left: auto; background: transparent; border: 0; font-size: 24px; padding: 4px; }
@keyframes page-loading { from { transform: translateX(-100%); } to { transform: translateX(350%); } }
@media (prefers-reduced-motion: reduce) { .page-navigation__track span { animation: none; width: 100%; } }
</style>
